/**
 * P3-36: PlanetBuildingBtn —— 行星建筑按钮（迁移自 PlanetBuildingBtnController）。
 */
import type { GamePage } from "../../bridge/GameBridge";
import type { BuildingBtnControllerLike } from "../bonfire/BuildingBtn";
import { SpaceBuildingBtn } from "./SpaceBuildingBtn";

export interface PlanetBuildingBtnProps {
  buildingName: string;
}

function getController():
  | (new (game: GamePage) => BuildingBtnControllerLike)
  | undefined {
  const w = window as unknown as {
    classes?: {
      ui?: {
        space?: {
          PlanetBuildingBtnController?: new (
            game: GamePage,
          ) => BuildingBtnControllerLike;
        };
      };
    };
  };
  return w.classes?.ui?.space?.PlanetBuildingBtnController;
}

export function PlanetBuildingBtn({ buildingName }: PlanetBuildingBtnProps) {
  return (
    <SpaceBuildingBtn
      id={buildingName}
      name={buildingName}
      description=""
      getController={getController}
      type="spaceBuilding"
    />
  );
}
